import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

interface Category {
  id: number;
  name_ar: string;
  name_en: string;
  slug: string;
  icon: string | null;
  type: string;
  ads_count?: number;
}

const categoryEmojis: Record<string, string> = {
  sheep: '🐑', camels: '🐪', goats: '🐐', cattle: '🐄', horses: '🐎', birds: '🐦',
};

const CategoriesPage: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/categories')
      .then((res) => setCategories(res.data.data || []))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '28px 24px 40px', boxSizing: 'border-box', fontFamily: "'Tajawal', sans-serif", color: '#17241F' }} dir="rtl">
      <nav aria-label="مسار التنقل" style={{ display: 'flex', gap: 8, fontSize: 13, color: '#6E7C76' }}>
        <Link to="/" style={{ textDecoration: 'none', color: '#6E7C76' }}>الرئيسية</Link><span>›</span><span>التصنيفات</span>
      </nav>
      <h1 style={{ margin: '14px 0 6px', fontFamily: "'Cairo', sans-serif", fontSize: 32, fontWeight: 800 }}>التصنيفات</h1>
      <p style={{ margin: '0 0 24px', fontSize: 16, color: '#5D6B65' }}>تصفّح المواشي حسب النوع</p>

      {loading ? (
        <p style={{ color: '#9AA6A1', textAlign: 'center', padding: '40px 0' }}>جاري التحميل...</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 16 }}>
          {categories.map((cat) => (
            <Link key={cat.id} to={'/categories/' + cat.slug}
              style={{ padding: '26px 18px', borderRadius: 20, background: '#FFFFFF', border: '1px solid #E6ECE9', textDecoration: 'none', color: '#17241F', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, textAlign: 'center', transition: 'box-shadow .15s' }}
              onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 6px 18px rgba(0,40,32,0.08)')}
              onMouseLeave={(e) => (e.currentTarget.style.boxShadow = 'none')}>
              <span style={{ width: 72, height: 72, borderRadius: 20, background: '#E7F2EE', color: '#005343', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 34 }}>
                {categoryEmojis[cat.slug] || '📦'}
              </span>
              <span style={{ fontFamily: "'Cairo', sans-serif", fontSize: 18, fontWeight: 700 }}>{cat.name_ar}</span>
              {cat.name_en && <span style={{ fontSize: 13, color: '#8A9792' }} dir="ltr">{cat.name_en}</span>}
              {typeof cat.ads_count === 'number' && cat.ads_count > 0 && (
                <span style={{ fontSize: 12.5, fontWeight: 700, color: '#005343' }}>{cat.ads_count.toLocaleString()} إعلان</span>
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoriesPage;
